import t from "react";
import { ListItemIcon as y, useTheme as p, Typography as b, ListItemAvatar as k, Avatar as L, MenuItem as C, ListItemText as M } from "@mui/material";
import { I as w } from "./chunk.zlc_6vey.js";
import { C as N } from "./chunk.CxHEbi_u.js";
import { jsx as v } from "react/jsx-runtime";
import { createSvgIcon as S } from "@mui/material/utils";
const i = "24px", g = "36px", T = (e) => {
  var n;
  return /* @__PURE__ */ t.createElement(k, { sx: { minWidth: g } }, /* @__PURE__ */ t.createElement(
    L,
    {
      id: e.id,
      alt: e.userName ? e.userName : e.id,
      src: e.imgSrc,
      sx: { width: i, height: i }
    },
    (n = e.userName) == null ? void 0 : n.charAt(0)
  ));
}, x = (e) => {
  const n = {
    variant: e.iconVariant,
    icon: e.iconName
  };
  return /* @__PURE__ */ t.createElement(
    y,
    {
      id: e.id,
      sx: {
        minWidth: g
      }
    },
    /* @__PURE__ */ t.createElement(
      w,
      {
        ...n,
        "aria-label": e.ariaLabel,
        sx: { width: i, height: i }
      }
    )
  );
}, I = (e) => {
  const n = p();
  return /* @__PURE__ */ t.createElement(
    b,
    {
      id: e.id,
      variant: "caption",
      sx: { color: n.palette.grey[700] }
    },
    e.text
  );
}, z = S(/* @__PURE__ */ v("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), _ = (e, n, r, o) => {
  if (o === "checkbox")
    return /* @__PURE__ */ t.createElement(
      N,
      {
        value: n,
        onChange: () => {
        },
        ariaLabel: `menu-item-${r}`
      }
    );
  if (e)
    switch (e.type) {
      case "avatar":
        return /* @__PURE__ */ t.createElement(
          T,
          {
            ...e.props
          }
        );
      case "icon":
        return /* @__PURE__ */ t.createElement(x, { ...e.props });
    }
  return null;
};
function q(e) {
  const {
    value: n,
    startElement: r,
    label: o,
    labelNode: u,
    description: s,
    descriptionNode: f,
    endIcon: d,
    endText: h,
    variant: l,
    onClick: E,
    ...a
  } = e, m = typeof a["aria-selected"] == "boolean" ? !!a["aria-selected"] : !!a.selected, c = p();
  return s && s.split(`
`).length > 3 && console.warn("Description should not span more than 3 new lines"), /* @__PURE__ */ t.createElement(
    C,
    {
      ...a,
      "aria-selected": m,
      value: n,
      key: n,
      sx: {
        paddingLeft: l === "checkbox" ? c.spacing(1) : c.spacing(2)
      },
      onClick: E
    },
    _(r, m, n, l),
    /* @__PURE__ */ t.createElement(
      M,
      {
        sx: { paddingLeft: c.spacing(1) },
        primary: u || o,
        secondary: f || s,
        secondaryTypographyProps: { sx: { whiteSpace: "pre-line" } }
      }
    ),
    h && /* @__PURE__ */ t.createElement(I, { text: h }),
    d && /* @__PURE__ */ t.createElement(x, { ...d }),
    l === "checkmark" && m && /* @__PURE__ */ t.createElement(z, { sx: { marginLeft: c.spacing(1) } })
  );
}
export {
  z as C,
  q as M
};
